angular.module('impactx.copyToClipBoard', ['ngRoute']);